import { orpc, rpcClient } from 'src/api/rpc/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'src/context/ToastContext';

export function useReprocessInboundEmail() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation({
    mutationFn: async ({
      inboundEmailId,
      forceFreshExtraction,
    }: {
      inboundEmailId: string;
      /** Extract the documents again instead of reusing cached results. */
      forceFreshExtraction?: boolean;
    }) => {
      return rpcClient.communications.inboundEmails.reprocess({
        inboundEmailId,
        forceFreshExtraction: forceFreshExtraction || undefined,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: orpc.communications.inboundEmails.list.key(),
      });

      showToast({
        message: 'Email queued for reprocessing',
        color: 'success',
        icon: 'check_circle',
      });
    },
    onError: (error) => {
      console.error('Failed to reprocess email:', error);
      showToast({
        message: 'Failed to reprocess email',
        color: 'error',
        icon: 'error',
      });
    },
  });
}
